export default "__VITE_ASSET__DhGOM7_R__"